



















































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { Retailer } from '@/models/BookMeetingFlow';
import { websiteText } from '@/mixins/websiteTexts';

@Component
class Item extends Vue {
    [x: string]: any;
    @Prop() retailer!: Retailer;
    @Prop() index!: number;
    @Prop() isClosestBrandStore!: boolean;
    /** Block/website level flag — the retailer can also carry its own. */
    @Prop({ type: Boolean, default: false }) useNewMeetingBooking!: boolean;

    get isConceptStore() {
        return this.retailer.organizationType === 'ConceptStore';
    }

    get usesNewMeetingBooking(): boolean {
        return this.useNewMeetingBooking || !!this.retailer.useNewMeetingBooking;
    }

    /** A different check marks the rows that run on the new booking solution. */
    get meetingTypeIconClass(): string {
        return this.usesNewMeetingBooking ? 'icon-check-done-16' : 'icon-success';
    }

    /**
     * On the new solution availableMeetingTypes is the only source — the old booking urls must
     * never decide anything for a retailer that has been switched over.
     */
    hasMeetingType(type: 'store' | 'home' | 'video'): boolean {
        if (this.usesNewMeetingBooking) {
            const types = this.retailer.availableMeetingTypes;
            return !!types && types.indexOf(type) !== -1;
        }

        const urls: Record<string, string | null> = {
            store: this.retailer.bookMeetingUrlStore,
            home: this.retailer.bookMeetingUrlHome,
            video: this.retailer.bookMeetingUrlVideo
        };
        return !!urls[type];
    }

    get hasAnyMeetingType(): boolean {
        return this.hasMeetingType('store') || this.hasMeetingType('home') || this.hasMeetingType('video');
    }

    public handleClick() {
        this.$emit('selected', { index: this.index, organizationId: this.retailer.organizationSystemId });
    }
}
export default Item;
